import React from 'react'
import { useEffect,useState } from 'react';
import ApiUrl from '../../../../configTools/apiUrl';
import ScreenSizes from '../../../../configTools/screenSizes';
import { Link } from 'react-router-dom';
import BlueButton from '../../../../components/forms/blueButton';
import GreenButton from '../../../../components/forms/greenButton';
import {ReactComponent as ViewIcon} from '../../../../images/icons/view.svg'
import {ReactComponent as EditIcon} from '../../../../images/icons/edit.svg'

const Listings = ({username}) => {
    const widths = window.innerWidth;
    const [products,setProducts] = useState([]);
    useEffect(() => {
      fetch(ApiUrl.API_URL_ListingUser+"/"+username)
      .then(res=>res.json())
      .then(data =>{
          if(data.success)
          setProducts(data.responce);
      });
    },[username])
  return (
    <div className='admin_forms_main_container'>
      <div className='public_home_product_grid_1_container'>
        <div className='public_home_product_grid_4_products'>
        {
            products.map((Product,index)=>{
                return(
                    <div style={{width:String((100/(parseInt(widths > ScreenSizes.Mobile? 5 : 3))))+"%", padding:"0.1%"}} key={index}>
                    <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+Product.image})`}}>
                        <div className='public_home_product_grid_1_products_item_overlay'>
                            <div className='public_home_product_grid_1_products_item_overlay_price'>
                                <div className='listing_bottom_buttons'>
                                    <Link to={'/product/'+Product.slug} target="_blank" rel="noopener noreferrer"><BlueButton Value={<ViewIcon width={'10px'} height={'10px'}/>}/></Link>
                                    <Link to={'/admin/products/listing/edit/'+Product.id}><GreenButton Value={<EditIcon width={'10px'} height={'10px'}/>}/></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                )
            })
        }
        </div>
      </div>
    </div>
  )
}

export default Listings
